/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */

const state = {
  ongoingSeason: '2018-2019',
  currentSeason: '',
  currentSeasonId: 0,
  currentCategoryId: 0,
  currentRegionId: 0,
  currentTeamId: 0,
  currentTournamentId: 0,
  currentDivisionId: 0,
};

const getters = {
  ongoingSeason: state => state.ongoingSeason,
  currentSeason: state => state.currentSeason,
  currentSeasonId: state => state.currentSeasonId,
  currentCategoryId: state => state.currentCategoryId,
  currentRegionId: state => state.currentRegionId,
  currentTeamId: state => state.currentTeamId,
  currentTournamentId: state => state.currentTournamentId,
  currentDivisionId: state => state.currentDivisionId,
};

const mutations = {
  updateCurrentSeason: (state, payload) => {
    state.currentSeason = payload;
  },
  updateCurrentSeasonId: (state, payload) => {
    state.currentSeasonId = payload;
  },
  updateCurrentCategoryId: (state, payload) => {
    state.currentCategoryId = payload;
  },
  updateCurrentRegionId: (state, payload) => {
    state.currentRegionId = payload;
  },
  updateCurrentTeamId: (state, payload) => {
    state.currentTeamId = payload;
  },
  updateCurrentTournamentId: (state, payload) => {
    state.currentTournamentId = payload;
  },
  updateCurrentDivisionId: (state, payload) => {
    state.currentDivisionId = payload;
  },
};

const actions = {
  updateCurrentSeason({ commit }, payload) {
    commit('updateCurrentSeason', payload);
  },
  updateCurrentSeasonId({ commit }, payload) {
    commit('updateCurrentSeasonId', payload);
  },
  updateCurrentCategoryId({ commit }, payload) {
    commit('updateCurrentCategoryId', payload);
  },
  updateCurrentRegionId({ commit }, payload) {
    commit('updateCurrentRegionId', payload);
  },
  updateCurrentTeamId({ commit }, payload) {
    commit('updateCurrentTeamId', payload);
  },
  updateCurrentTournamentId({ commit }, payload) {
    commit('updateCurrentTournamentId', payload);
  },
  updateCurrentDivisionId({ commit }, payload) {
    commit('updateCurrentDivisionId', payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
